import { render, staticRenderFns } from "./noLogin_coursePlay.vue?vue&type=template&id=3824b05d&scoped=true"
import script from "./noLogin_coursePlay.vue?vue&type=script&lang=js"
export * from "./noLogin_coursePlay.vue?vue&type=script&lang=js"
import style0 from "./noLogin_coursePlay.vue?vue&type=style&index=0&id=3824b05d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3824b05d",
  null
  
)

export default component.exports